import { RootState } from "../../rootReducer";

export const selectIsDeletingBusinessUser = (state: RootState) =>
  state.deleteBusinessUser.loading;
export const deleteBusinessUserErrorMessage = (state: RootState) =>
  state.deleteBusinessUser.error;
export const deleteBusinessUserResponse = (state: RootState) =>
  state.deleteBusinessUser.deleteBusinessUserResponse;
